import axios from "axios";

export default {
  data() {
    return {};
  },
  methods: {
    readQuery: function (endpoint, data, successAction, failureAction) {
      this.query(endpoint, data, successAction, failureAction, false, false);
    },
    createQuery: function (endpoint, data, successAction, failureAction, itemType, itemName) {
      let successToastTitle = itemType + ' Created';
      let successToastMessage = '"' + itemName + '" was created successfully.';
      let failureToastTitle = 'Error Creating ' + itemType;
      this.query(endpoint, data, successAction, failureAction, successToastTitle, failureToastTitle, successToastMessage);
    },
    updateQuery: function (endpoint, data, successAction, failureAction, itemType, itemName) {
      let successToastTitle = itemType + ' Saved';
      let successToastMessage = 'Your changes to "' + itemName + '" were saved successfully.';
      let failureToastTitle = 'Error Saving ' + itemType;
      this.query(endpoint, data, successAction, failureAction, successToastTitle, failureToastTitle, successToastMessage);
    },
    deleteQuery: function (endpoint, data, successAction, failureAction, itemType, itemName) {
      let successToastTitle = itemType + ' Deleted';
      let successToastMessage = '"' + itemName + '" was deleted successfully.';
      let failureToastTitle = 'Error Deleting ' + itemType;
      this.query(endpoint, data, successAction, failureAction, successToastTitle, failureToastTitle, successToastMessage);
    },
    query: function (endpoint, data, successAction, failureAction, successToastTitle, failureToastTitle, successToastMessage) {
      axios
        .post(endpoint, data)
        .then(response => {
          //console.log(response);

          let parent = this.$parent;
          let toaster = null;
          while (parent) {
            toaster = parent.showToast;
            if (toaster)
              break;
            parent = parent.$parent;
          }

          if (response.data.errors) {
            let errorMessage = response.data.errors.map(e => e.message).join(' ');

            if (failureToastTitle && toaster)
              toaster(errorMessage, {
                title: failureToastTitle,
                variant: 'danger',
                autoHideDelay: 5000
              });
            
            if (failureAction)
              failureAction(response.data.errors);
              
          } else if (response.data.data) {
            if (successToastTitle && toaster)
              toaster(successToastMessage, {
                title: successToastTitle,
                variant: 'success',
                autoHideDelay: 5000
              });

            if (successAction)
              successAction(response.data.data);

            // if (response.data.errors) {
            //   let errorMessage = response.data.errors.map(e => e.message).join(' ');
  
            //   if (toaster)
            //     toaster(errorMessage, {
            //       title: 'Data Load Warning',
            //       variant: 'warning',
            //       autoHideDelay: 5000
            //     });
            // }              
          } else {
            if (failureToastTitle && toaster)
              toaster('Unexpected error: ' + response.statusText, {
                title: failureToastTitle,
                variant: 'danger',
                autoHideDelay: 5000
              });

            if (failureAction)
              failureAction();
          }
        })
        .catch(error => {
          console.log(error);

          let parent = this.$parent;
          let toaster = null;
          while (parent) {
            toaster = parent.showToast;
            if (toaster)
              break;
            parent = parent.$parent;
          }

          if (failureToastTitle && toaster)
            toaster.showToast('Unexpected error: ' + error.response.statusText, {
              title: failureToastTitle,
              variant: 'danger',
              autoHideDelay: 5000
            });

          if (failureAction)
            failureAction();
        });      
    }
  }
}
